import React, { useState } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  Paper,
  Popover,
  Slider,
  Typography,
  Box,
} from "@mui/material";

const PassingCriteriaPopover = ({ showInterview, value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [resumeValue, setResumeValue] = useState(value?.resume_score || 100);
  const [interviewValue, setInterviewValue] = useState(value?.interview_score || 100);

  const marks = [
    { value: 0, label: "0%" },
    { value: 20, label: "20%" },
    { value: 40, label: "40%" },
    { value: 60, label: "60%" },
    { value: 80, label: "80%" },
    { value: 100, label: "100%" },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);


  const handleApply = () => {
    if (showInterview) {
      onChange({ interview_score: interviewValue, resume_score: resumeValue })
    } else {
      onChange({ resume_score: resumeValue })
    }
    handleClose()
  };

  return (
    <div>
      <Button
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        sx={{
          borderColor: "divider",
          textTransform: "none",
          fontStyle: "Outfit",
          py: 1.5,
          fontSize: '14px',
          color: "#848694",
          borderRadius: '7px',
          "&:hover": {
            borderColor: "primary.main",
          },
        }}
      >
        Passing criteria
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Paper sx={{ p: 3, width: { xs: '100vw', md: 600 } }}>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Resume screening passing criteria
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Candidates are considered passed when their resumes match at least
              60% of the given requirements
            </Typography>
            <Box
              sx={{
                px: 3,
                py: 1,
                boxShadow: "0px 0px 20px 3px #0000000D",
                borderRadius: 10,
              }}
            >
              <Slider
                value={resumeValue}
                onChange={(_, newValue) => {
                  setResumeValue(newValue)
                }}
                marks={marks}
                min={0}
                max={100}
                sx={{
                  height: 8,
                  "& .MuiSlider-track": {
                    border: "none",
                    background:
                      "linear-gradient(90deg, #8EEBFF 0%, #4BC7E1 100%)",
                  },
                  "& .MuiSlider-rail": {
                    opacity: 0.5,
                    backgroundColor: "#E0E0E0",
                  },
                  "& .MuiSlider-thumb": {
                    height: 24,
                    width: 24,
                    backgroundColor: "#fff",
                    border: "3px solid #9147F5",
                  },
                  "& .MuiSlider-mark": {
                    backgroundColor: "#B6E5FF",
                    height: 8,
                    width: 8,
                    borderRadius: "50%",
                  },
                }}
              />
            </Box>
          </Box>
          {showInterview &&
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Interview passing criteria
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Candidates are considered passed when their resumes match at least 60% of the given requirements
              </Typography>
              <Box
                sx={{
                  px: 3,
                  py: 1,
                  boxShadow: "0px 0px 20px 3px #0000000D",
                  borderRadius: 10,
                }}
              >
                <Slider
                  value={interviewValue}
                  onChange={(_, newValue) => setInterviewValue(newValue)}
                  marks={marks}
                  min={0}
                  max={100}
                  sx={{
                    height: 8,
                    "& .MuiSlider-track": {
                      border: "none",
                      background:
                        "linear-gradient(90deg, #8EEBFF 0%, #4BC7E1 100%)",
                    },
                    "& .MuiSlider-rail": {
                      opacity: 0.5,
                      backgroundColor: "#E0E0E0",
                    },
                    "& .MuiSlider-thumb": {
                      height: 24,
                      width: 24,
                      backgroundColor: "#fff",
                      border: "3px solid #9147F5",
                    },
                    "& .MuiSlider-mark": {
                      backgroundColor: "#B6E5FF",
                      height: 8,
                      width: 8,
                      borderRadius: "50%",
                    },
                  }}
                />
              </Box>
            </Box>
          }
          <Box display='flex' justifyContent='flex-end' gap={2}>
            <Button variant='outlined' sx={{ borderColor: '#B7B7B7', border: 1, borderRadius: '30px', bgcolor: 'transparent', color: '#595959' }} onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='main' sx={{ bgcolor: 'purple.main' }} onClick={handleApply}>
              Confirm
            </Button>
          </Box>
        </Paper>
      </Popover>
    </div>
  );
};

export default PassingCriteriaPopover;
